import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Col, Modal, ModalBody, ModalFooter } from 'react-bootstrap';
import Button from '../../../../components/Button';
import CalloutCard from '../../../../components/CalloutCard';
import ModalHeader from '../../../../components/ModalHeader';
import Radio, { RadioGroup } from '../../../../components/Radio';
import FederalTaxForm from './FederalTaxForm';

export type FederalTaxModalProps = {
  show: boolean;
  handleClose: () => void;
  data: any;
  collectData: (data: any) => void;
};

const FederalTax = ({
  show,
  handleClose,
  data,
  collectData,
}: FederalTaxModalProps) => {
  const [value, setValue] = React.useState<string | number>('state-tax');
  const [isExpanded, setExpanded] = React.useState<boolean>(false);
  const [updatedFederalTaxData, setUpdatedFederalTaxData] = useState(data);

  const handleChange = (e: string | number) => {
    setValue(e);
  };

  const handleUpdateFederalTaxData = (data: any) => {
    setUpdatedFederalTaxData(data);
  };

  const handleChangeData = (data: any) => {
    collectData(data);
  };

  useEffect(() => {
    if (show) {
      //select the option by default after the dialog is shown on screen with 1s delay
      setTimeout(() => {
        setExpanded(true);
      }, 1000);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      className="custom-federal-tax-modal"
    >
      <ModalHeader closeButton>
        <h4>Federal Tax Withholding</h4>
      </ModalHeader>
      <ModalBody>
        <section>
          <CalloutCard cardIcon={light('screwdriver-wrench')}>
            <Col className="col-12">
              <div>
                <span className="bolder-text text-caption fw-bolder">
                  Need help deciding?
                </span>
              </div>
              <div>
                <span className="bolder-text text-caption fw-bolder ">
                  W-4P Help
                </span>
              </div>
              <div className="fw-light text-caption lh-xs pt-3 d-flex align-items-center cursor-pointer">
                <span className="mx-3 indigo-bullet"></span>
                <span className="text-indigo ">Instructions</span>
              </div>
              <div className="fw-light text-caption lh-xs pt-3 d-flex align-items-center cursor-pointer">
                <span className="mx-3 indigo-bullet"></span>
                <span className="text-indigo">Deductions Worksheet</span>
              </div>
              <div className="fw-light text-caption lh-xs pt-3 d-flex align-items-center cursor-pointer">
                <span className="mx-3 indigo-bullet"></span>
                <span className="text-indigo">W-4P Form</span>
              </div>
            </Col>
          </CalloutCard>
        </section>
        <section className="pt-13">
          <div>
            <h5 className="pb-7 border-bottom">
              Do you want to withhold taxes from your payment?
            </h5>
            <div className="mt-7">
              <span className="text-caption fw-light lh-xs">
                
              </span>
            </div>
            <div className="mt-7">
              <RadioGroup
                name={'state-tax'}
                value={value}
                onChange={handleChange}
              >
                <div
                  className={`radio-group ${
                    value === '2' ? 'selected-radio' : ''
                  }`}
                >
                  <div className="d-flex justify-content-between radio-title py-5">
                    <div className="radio-btn-col">
                      <Radio
                        value={'2'}
                        id={'2'}
                        label={
                          'Yes, Withhold taxes - I want taxes withheld from each payment.'
                        }
                      />
                    </div>
                    <div
                      className="radio-btn-col radio-btn-icon ms-7 ms-lg-0 click-area"
                      onClick={() => setExpanded(!isExpanded)}
                    >
                      <FontAwesomeIcon
                        icon={light('chevron-down')}
                        className={`${
                          isExpanded ? 'clicked-arrow-svg' : 'arrow-svg'
                        }`}
                      />
                    </div>
                  </div>
                  {isExpanded && (
                    <div className="mt-11 px-3 px=lg-10">
                      <FederalTaxForm
                        data={updatedFederalTaxData}
                        collectData={handleUpdateFederalTaxData}
                      />
                    </div>
                  )}
                </div>
                <div className={`radio-group`}>
                  <div className="d-flex justify-content-between pt-5">
                    <div className="radio-btn-col">
                      <Radio
                        value={'1'}
                        id={'1'}
                        label={
                          'Do not withhold taxes - I will be responsible for any taxes owed.'
                        }
                      />
                    </div>
                  </div>
                </div>
              </RadioGroup>
            </div>
          </div>
        </section>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary-outline"
          onClick={() => {
            setUpdatedFederalTaxData(data);
            handleClose();
          }}
          className="mt-7 mt-lg-0"
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            handleChangeData(updatedFederalTaxData);
            handleClose();
          }}
          className="mt-7 mt-lg-0"
        >
          Change
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FederalTax;
